module.exports = __webpack_public_path__ + "static/integration_img_mobile-51d73bf735cb072a81e3a21445e306da.webp";